import React from "react";
import IndustryPage from "./IndustryPage";

const ManufacturingPage: React.FC = () => {
  return <IndustryPage industryKey="manufacturing" />;
};

export default ManufacturingPage;
